export enum EGeolocationFailedPopup {
  ShowPopup = 'showGeolocationFailedPopup'
}
